import { useLoading } from '@/contexts/loading'
import Image from 'next/image'
import { createPortal } from 'react-dom'

interface LoadingProps {
  message?: string
}

const LoadingOverlay = ({ message }: LoadingProps) => (
  <div className='fixed inset-0 z-50'>
    <div className='flex min-h-screen justify-center items-center bg-white/95'>
      <LoadingContent message={message} />
    </div>
  </div>
)

const LoadingContent = ({ message }: LoadingProps) => (
  <div className='flex flex-col items-center'>
    <Image
      src='/loading.gif'
      alt='loading'
      width={100}
      height={100}
      unoptimized
      priority
    />
    <LoadingText message={message} />
  </div>
)

const LoadingText = ({ message }: LoadingProps) => (
  <div className='pt-5 font-light text-lg'>
    {message || 'กำลังโหลด กรุณารอสักครู่...'}
  </div>
)

const Loading = ({ message }: LoadingProps) => {
  const { isLoading } = useLoading()
  if (!isLoading) return null

  return createPortal(<LoadingOverlay message={message} />, document.body)
}

export default Loading
